export type AbaChatContatos = 'TODOS' | 'NAO_LIDOS' | 'FAVORITOS';

export class FiltroChatContatos {
  textoFiltro = '';
  aba: AbaChatContatos = 'TODOS';
  idsCanais: number[] = [];
  idsOperadores: number[] = [];
}
